<div>
    <h1 class="bg-azul text-white p-5 text-center text-xl">{{'select-idioma' | translate}}</h1>
    <div mat-dialog-content>
        <div>
            <mat-select-country label="{{'idioma' | translate}}" [value]="idiomaPorDefecto" [countries]="idiomas" (onCountrySelected)="cambiarIdioma($event)"></mat-select-country>
        </div>
    </div>
    <div>
        <div class="flex justify-center m-5">
            <button type="submit" class="bg-azul text-white p-2 cursor-pointer rounded-lg hover:text-blue-300 duration-1000" (click)="confirmar()">{{'confirmar' | translate}}</button>
        </div>
    </div>
</div>